import defaultStyled, { StyledComponent } from "@emotion/styled";

export type AsProps = {
  as?: React.ElementType | string;
};

export type EmotionComponent<
  Props,
  HTMLProps extends {} = {}
> = StyledComponent<HTMLProps, Props & AsProps>;

export const styled = defaultStyled;
